import { RootState } from '../../../applicationStore';
import { TimesheetsState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getTimesheetsState = (state: RootState): TimesheetsState =>
  state.timesheets;

export const getTimesheetsLoader = createSelector(
  getTimesheetsState,
  (state): boolean => state.loading,
);

export const getTimesheetsData = createSelector(
  getTimesheetsState,
  (state): TimesheetsState['data'] | null => state?.data || [],
);
